export default __webpack_public_path__ + "static/media/calendar.9d2718a7.svg";